import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ZodError, ZodIssue } from 'zod';

@Injectable({
    providedIn: 'root',
})
export class ZodService {
    getIssuesByRow(issues: ZodIssue[]) {
        return _.groupBy(issues, (issue) => issue.path[0]);
    }

    getIssuesByTabAndRow(
        tabErrors: Map<string, ZodError>
    ): Map<string, _.Dictionary<ZodIssue[]>> {
        const result = new Map<string, _.Dictionary<ZodIssue[]>>();

        for (const [tabName, error] of tabErrors) {
            const issuesByRow = this.getIssuesByRow(error.issues);
            result.set(tabName, issuesByRow);
        }

        return result;
    }
}
